"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requestHelper = _interopRequireDefault(require("../requestHelper"));

var _jsencrypt = _interopRequireDefault(require("jsencrypt"));

var _md5Helper = _interopRequireDefault(require("../md5Helper"));

var hex_md5 = _md5Helper["default"].hex_md5;
var requestHandle = _requestHelper["default"].requestHandle;
var KEY_SIZE = 'keySize';
var SUNSHINE_INFO = 'sunshineInfo';
var REFRESH_CODE = 101016;

var clearPublicKey = function clearPublicKey() {
  window.localStorage.removeItem(SUNSHINE_INFO);
  window.localStorage.removeItem(KEY_SIZE);
};

var request$getPublicKey = function () {
  var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    var params,
        success,
        fail,
        complete,
        headers,
        res,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
              success: function success() {
                return null;
              },
              fail: function fail() {
                return null;
              },
              complete: function complete() {
                return null;
              },
              headers: {}
            };
            success = params.success, fail = params.fail, complete = params.complete, headers = params.headers;
            _context.prev = 2;
            _context.next = 5;
            return requestHandle({
              url: '/passport/login/getSunshineInfo',
              openBdHeader: true,
              headers: headers
            });

          case 5:
            res = _context.sent;

            if (res && res.data && res.data.sunshineInfo) {
              if (success instanceof Function) {
                success(res);
              }

              window.localStorage.setItem(SUNSHINE_INFO, res.data.sunshineInfo);
              window.localStorage.setItem(KEY_SIZE, res.data.keySize);
            } else {
              if (fail instanceof Function) {
                fail(res);
              }
            }

            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

            if (fail instanceof Function) {
              fail(_context.t0);
            }

            console.error(_context.t0);

          case 13:
            _context.prev = 13;

            if (complete instanceof Function) {
              complete();
            }

            return _context.finish(13);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9, 13, 16]]);
  }));

  return function request$getPublicKey() {
    return _ref.apply(this, arguments);
  };
}();

var encryptPassword = function encryptPassword(pwd) {
  var publicKey = window.localStorage.getItem(SUNSHINE_INFO);
  var keySize = window.localStorage.getItem(KEY_SIZE);
  var encryptor = new _jsencrypt["default"]({
    default_key_size: keySize
  });
  encryptor.setPublicKey(publicKey);
  var rsaPassWord = encryptor.encrypt(pwd);
  return rsaPassWord;
};

var getParams = function getParams(pwd) {
  var publicKey = window.localStorage.getItem(SUNSHINE_INFO);
  var encryptPass = encryptPassword(pwd);
  return {
    isCipher: true,
    encryptPass: encryptPass,
    md5Str: hex_md5(publicKey).toUpperCase()
  };
};

var _default = {
  getParams: getParams,
  encryptPassword: encryptPassword,
  REFRESH_CODE: REFRESH_CODE,
  clearPublicKey: clearPublicKey,
  request$getPublicKey: request$getPublicKey
};
exports["default"] = _default;